import React from "react";
import styles from "./SliderItem.module.css";

import Typography from "@material-ui/core/Typography";
import history from "core/helper/Helper";
import { RouterName } from "shared/RouterName";

const SliderItem = ({ imgPath, label, id, onChange }) => {
  const handelToCategoryParent = () => {
    history.push(`${RouterName.Products.category.url}/${id}`);
  };

  return (
    <span
      className={styles.slider_single_item}
      style={{ backgroundImage: `url(${imgPath})` }}
    >
      <div className={styles.content_container_opacity}>{""}</div>
      <div className={styles.content}>
        <Typography
          variant="h5"
          gutterBottom
          className={`${
            onChange
              ? styles.title_transfer_right_to_left
              : styles.title_transfer_top_to_bottom
          } ${styles.title}`}
        >
          {label}
        </Typography>
        <div
          className={`${
            onChange
              ? styles.bonus_transfer_right_to_left
              : styles.bonus_transfer_top_to_bottom
          } ${styles.information_bonus}`}
        >
          <Typography variant="body1" gutterBottom>
            Xem nhiều sản phẩm hơn...
          </Typography>
        </div>
        <div
          onClick={handelToCategoryParent}
          className={`${
            onChange
              ? styles.btn_transfer_right_to_left
              : styles.btn_transfer_top_to_bottom
          } ${styles.btn_buy_now}`}
        >
          <Typography variant="button" display="block" gutterBottom>
            Xem Ngay
          </Typography>
        </div>
      </div>
    </span>
  );
};

export default SliderItem;
